import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import Form from '../components/CategoryForm';
import {CLINICAL_NOTE_WRITING_CATEGORY_CONSTRAINS} from 'constants/adminPupups';

const ADD_CATEGORY_API = '/api/v1/note_categories';

@inject('clinicalNoteWritingCategoriesStore')
@inject('alertStore')
@observer
class Add extends PureComponent {
  componentDidMount() {
    const {clinicalNoteWritingCategoriesStore} = this.props;
    clinicalNoteWritingCategoriesStore.initNewCategory();
  }

  validationProcess = resource => {
    let errors = validate(resource, CLINICAL_NOTE_WRITING_CATEGORY_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {clinicalNoteWritingCategoriesStore} = this.props;
    const category = _.assign({}, clinicalNoteWritingCategoriesStore.category);
    const errors = this.validationProcess(category);

    clinicalNoteWritingCategoriesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', category.title);

    new HttpClient().multipart(ADD_CATEGORY_API, formData, 'POST').then(data => {
      clinicalNoteWritingCategoriesStore.saveCategory(data.body.data.note_category);
      clinicalNoteWritingCategoriesStore.initNewCategory();
      this.props.alertStore.success('You successfully created Category');
      this.props.history.push('/clinical-notes-writing');
      
    }).catch(() => {
      this.props.alertStore.error('Something went wrong');
    });
  };

  render() {
    return (
      <PageWrapper>
        <Form submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/Add.js